import IAccountStatementsReducer from "models/IAccountStatementsReducer";
import { actionTypes } from "./actions";
import { accountStatementsSorting as defaultSorting } from "constants/sorting";
import produce from "immer";

const initialState: IAccountStatementsReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_ACCOUNT_STATEMENTS_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_ACCOUNT_STATEMENTS_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
